import { testimonials } from "@/mocks/testimonials";

export default function TrustSection() {
  return (
    <section id="trust" className="w-full py-20 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-5 h-5 rounded-sm bg-secondary-500 flex items-center justify-center">
              <i className="ri-check-line text-background-50 text-xs"></i>
            </span>
            <span className="text-sm font-semibold text-secondary-600 uppercase tracking-wider">Community Verified</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Trusted by 10,000+ Shoppers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.slice(0, 3).map((t, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-3xl text-secondary-300 block leading-none mb-3"></i>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.quote}</p>
            </div>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.slice(3, 5).map((t, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-3xl text-secondary-300 block leading-none mb-3"></i>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.quote}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}